import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const Header: React.FC = () => {
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false)

	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen)
	}

	// Общий список навигационных пунктов
	const navItems = [
		{ name: 'Home', to: '/' },
		{ name: 'Register', to: '/register' },
		{ name: 'Downloads', to: '/downloads' },
		{ name: 'Rankings', to: '/rankings' },
		{ name: 'Guides', to: '' },
		{ name: 'Discord', href: '/' },
		{ name: 'Facebook', to: '/' },
		{ name: 'Event Schedule', to: '/events' },
	]

	return (
		<header className='header flex flex-col justify-between items-center bg-transparent bg-opacity-90 p-4 min-h-[280px]'>
			<div className='container mx-auto flex justify-center items-center'>
				{/* Кнопка мобильного меню */}
				<button
					id='mobile-menu-button'
					className='lg:hidden px-2 py-1 text-red-400 hover:text-red-500 transition duration-300'
					onClick={toggleMobileMenu}
					aria-label='Menu'
				>
					Меню
				</button>

				{/* Навигация для десктопа */}
				<nav className='hidden lg:flex lg:items-center lg:space-x-4 font-semibold text-lg'>
					{navItems.map((item, index) => {
						const isLastItem = index === navItems.length - 1
						return (
							<Link
								key={index}
								to={item.to!}
								className={`transition duration-300 rounded-md hover:bg-primary text-sm xl:text-base ${
									isLastItem
										? 'bg-opacity-70 hover:bg-opacity-100 bg-cyan-500 text-white px-4 py-2 xl:px-6 xl:py-4'
										: 'hover:bg-opacity-70 hover:bg-cyan-300 px-2 py-1 xl:px-3 xl:py-2'
								}`}
							>
								{item.name}
							</Link>
						)
					})}
				</nav>
			</div>
			<div className='container flex min-h-full'></div>

			{/* Мобильное меню */}
			<div
				id='mobile-menu'
				className={`lg:hidden w-full ${isMobileMenuOpen ? 'block' : 'hidden'}`}
			>
				<nav className='flex flex-col space-y-2 p-4 bg-gray-700 rounded-lg mt-2'>
					{navItems.map((item, index) => (
						<Link
							key={index}
							to={item.to!}
							className='block hover:text-red-400 transition duration-300 px-2 py-1 rounded-md hover:bg-red-600 hover:bg-opacity-70 text-sm'
							onClick={() => setIsMobileMenuOpen(false)} // Закрываем меню при клике
						>
							{item.name}
						</Link>
					))}
				</nav>
			</div>
		</header>
	)
}

export default Header
